import videojs from 'video.js';
import youtube from 'videojs-youtube';

const controlVideoShadowbox = () => {
    const triggers = document.querySelectorAll('.video-trigger a');
    const shadowbox = document.getElementById('video-shadowbox');
    const closeBtn = document.getElementById('close-shadowbox');
    const overlay = shadowbox ? shadowbox.querySelector('.shadowbox-overlay') : null;
    
    let player = null;

    // Initialize Video.js player if the element exists
    if (document.getElementById('shadowbox-player')) {
        player = videojs('shadowbox-player');
    }

    // Function to determine video type
    function getVideoType(url) {
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
            return 'video/youtube';
        }
        return 'video/mp4'; // Default fallback for .mp4 links
    }

    // Handle trigger click events
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function(e) {
            e.preventDefault(); // Stop original link navigation
            
            const videoUrl = this.getAttribute('href');
            if (!videoUrl || !player) return;

            const videoType = getVideoType(videoUrl);

            console.log(videoUrl)

            // Update Video.js source and load the new video
            player.src({ type: videoType, src: videoUrl });
            player.ready(() => {
                player.play();
            });

            const loadingspinner = document.querySelector('.vjs-loading-spinner');

            if (loadingspinner) {
            // Add fade-out class with CSS transition
            loadingspinner.style.transition = 'opacity 0.4s ease';
            loadingspinner.style.opacity = '0';

            // Wait for animation to complete, then remove
            setTimeout(() => {
                loadingspinner.remove();
            }, 400);
            }

            // Show Shadowbox
            shadowbox.style.display = 'flex';
        });
    });

    // Close Shadowbox functionality
    function closeVideoModal() {
        if (shadowbox) {
            shadowbox.style.display = 'none';
            if (player) {
                player.pause();
                player.src(''); // Reset source
            }
        }
    }

    if (closeBtn) closeBtn.addEventListener('click', closeVideoModal);
    if (overlay) overlay.addEventListener('click', closeVideoModal);
}

export { controlVideoShadowbox }